/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_CoachesInputs */

const en_landing_nav_coaches = /** @type {(inputs: Landing_Nav_CoachesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaches`)
};

const pl_landing_nav_coaches = /** @type {(inputs: Landing_Nav_CoachesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy`)
};

/**
* | output |
* | --- |
* | "Coaches" |
*
* @param {Landing_Nav_CoachesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_nav_coaches = /** @type {((inputs?: Landing_Nav_CoachesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_CoachesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_nav_coaches(inputs)
	return en_landing_nav_coaches(inputs)
});